import { create } from 'zustand';

// Ephemeral UI-chrome state (NOT persisted) — mirrors the plain zustand pattern
// in brandingStore.ts. Lets a page tell the app shell to drop into an
// "immersive" mode that hides the global mobile bottom nav, so an in-page
// bottom UI (e.g. the patient chat composer + sticky sub-tabs) can own the
// bottom of the screen without a second bar stacking on top of it.

interface UiChromeStore {
  immersive: boolean;
  setImmersive: (v: boolean) => void;
}

// Single source of truth for the bar height + the content bottom-padding that
// clears it (see MainLayout).
export const BOTTOM_NAV_HEIGHT = 56;

export const useUiChromeStore = create<UiChromeStore>()((set) => ({
  immersive: false,
  setImmersive: (v: boolean) => set({ immersive: v }),
}));
